/**
 * * 扩展配置项，标签放置在正负值方向的位置上
 *
 * @example
 * ```javascript
 * {
 *   type: 'bar',
 *   label: {
 *     dvPosition: 'valueDirection'
 *   }
 * }
 * ```
 */
import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension.js';
import { type BarSeriesOption } from 'echarts/lib/export/option.js';
import { util } from 'echarts/core';
import { overrideIfUndefined } from '../../../util/data';

function parseBarLabelDvPosition(seriesOption: BarSeriesOption[]) {
  seriesOption.forEach(option => {
    if (
      // @ts-ignore
      option?.label?.dvPosition !== 'valueDirection' ||
      typeof option?.label?.position !== 'undefined'
    ) {
      return;
    }

    // ! 这里只处理了 data 放在 series 的情况，不处理 dataset 的情况
    if (typeof option.data === 'undefined') {
      // eslint-disable-next-line no-param-reassign
      option.data = [];
    }

    // eslint-disable-next-line no-param-reassign
    option.data = option.data.map(item => {
      let dataItem: any;
      
      if (util.isString(item) || (!util.isObject(item) && !util.isArray(item))) {
        dataItem = {
          value: item
        };
      } else {
        dataItem = item;
      }

      if (typeof dataItem.label === 'undefined') {
        // eslint-disable-next-line no-param-reassign
        dataItem.label = {};
      }

      // eslint-disable-next-line no-param-reassign
      dataItem.label.position = overrideIfUndefined(
        dataItem.label.position as string,
        Number(dataItem.value) >= 0 ? 'top' : 'bottom'
      );

      /** UI规范要求label到柱子的间距是4px */
      dataItem.label.offset = overrideIfUndefined(dataItem.label.offset, [
        0,
        Number(dataItem.value) >= 0 ? 2 : 0
      ]);

      return dataItem;
    });

    //
  });

  //
}

/**
 * 柱状图标签扩展
 */
export function install(registers: EChartsExtensionInstallRegisters) {
  // * ecModel.setOption() 时
  registers.registerPreprocessor(option => {
    const barSeries = (Array.isArray(option.series) ? option.series : [option.series]).filter(
      item => item.type === 'bar'
    );
    if (barSeries.length === 0) {
      return;
    }

    // @ts-ignore
    parseBarLabelDvPosition(barSeries);
  });
}
